import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IDeviceTypeNameEditorProps {
    value: string;
    onUpdate: (field: 'name', value: string) => void;
}

export default function DeviceTypeNameEditor({ value = '-', onUpdate }: IDeviceTypeNameEditorProps) {
    const { t } = useTranslation();
    return (
        <TextField
            fullWidth
            label={t('common:organization.projects.deviceType.name')}
            value={value}
            placeholder={'-'}
            onChange={(e) => onUpdate('name', e.target.value)}
        />
    );
}
